import Tooltip from "ds_legacy/components/Tooltip";
import { ERROR_COLOR, ICON_DARK } from "ds_legacy/materials/colors";
import { AlertTriangleIcon, LockIcon } from "lucide-react";
import { useState } from "react";
import { useTranslations } from "translations";

export function EncryptedTooltip({
  activateEncryption,
  isFile = false,
}: {
  activateEncryption: boolean;
  isFile?: boolean;
}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const translations = useTranslations();

  if (!activateEncryption)
    return (
      <Tooltip
        placement="right-start"
        title={translations.messenger.notEncryptedHint}
      >
        <AlertTriangleIcon size={16} style={{ color: ERROR_COLOR }} />
      </Tooltip>
    );

  return (
    <div
      aria-label={
        isFile
          ? translations.messenger.fileTransferEncrypted
          : translations.auctionResponse.sendEncryptedMessageHint
      }
      role="tooltip"
      tabIndex={0}
      onBlur={() => setTooltipOpen(false)}
      onFocus={() => setTooltipOpen(true)}
      onMouseEnter={() => setTooltipOpen(true)}
      onMouseLeave={() => setTooltipOpen(false)}
    >
      <Tooltip
        open={tooltipOpen}
        placement="top-start"
        title={
          isFile
            ? translations.messenger.fileTransferEncrypted
            : translations.auctionResponse.sendEncryptedMessageHint
        }
      >
        <LockIcon size={16} style={{ color: ICON_DARK }} />
      </Tooltip>
    </div>
  );
}

export default EncryptedTooltip;
